import { render, staticRenderFns } from "./acc-project-browser.vue?vue&type=template&id=7d22b824&scoped=true"
import script from "./acc-project-browser.vue?vue&type=script&lang=js"
export * from "./acc-project-browser.vue?vue&type=script&lang=js"
import style0 from "./acc-project-browser.vue?vue&type=style&index=0&id=7d22b824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22b824",
  null
  
)

export default component.exports